import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useAxios from 'axios-hooks';
import cn from 'classnames';

import userDefaultIcon from '../../../../img/user/icon-user-default.png';
import { API_URL } from '../../../config/constants';
import ProfilePicWrapper from './ProfilePicWrapper';
import { Button, ProfileTabs } from '../../../components';

const ProfilePic = ({ user }) => {
	const userRaw = user.toJSON();
	const [{ data, loading /* error */ }, getProfileImages] = useAxios({
		method: 'GET',
		url: `/provider_profile_images/${userRaw.id}/files`,
	});
	const [, /* { loading: isUploading } */ uploadImage] = useAxios(
		{
			method: 'POST',
			url: `/provider_profile_images/${userRaw.id}/upload`,
		},
		{
			manual: true,
		}
	);
	const [, /* { loading: isDeleting } */ deleteImage] = useAxios(
		{
			method: 'DELETE',
			url: `/provider_profile_images/${userRaw.id}/files`,
		},
		{
			manual: true,
		}
	);
	const [tempImages, setTempImages] = useState([]);

	const handleImageChange = ({ target }) => {
		setTempImages([...target.files]);
	};

	const handleDeleteImage = async (clearOld = true) => {
		if (data.length > 0) {
			await deleteImage({
				url: `/provider_profile_images/${userRaw.id}/files/${data[0].name}`,
			});
			if (clearOld) {
				user.set('profile_image_name', null);
				user.save();
				getProfileImages();
			}
		}
	};

	const handleUploadImage = () => {
		handleDeleteImage(false);
		const formData = new FormData();
		formData.append('file', tempImages[0]);
		uploadImage({
			data: formData,
			headers: {
				'content-type': 'multipart/form-data',
			},
		}).then(() => {
			getProfileImages().then(() => {
				user.fetch();
				setTempImages([]);
			});
		});
	};

	return (
		<div className="content-wrapper profile-pic">
			<ProfileTabs activeTab="pic" />
			<div className="form-horizontal mt-xl container">
				<div className="form-group">
					<label className="col-sm-3 control-label">Current Picture</label>
					<div className="col-sm-5 pics">
						{!loading &&
							Array.isArray(data) &&
							data.map((imageData) => (
								<ProfilePicWrapper
									key={imageData.name}
									imagePath={`${API_URL}/provider_profile_images/${userRaw.id}/download/${imageData.name}`}
									onDelete={handleDeleteImage}
								/>
							))}
						{!loading && Array.isArray(data) && data.length === 0 && (
							<img src={userDefaultIcon} />
						)}
					</div>
				</div>
				<div className="form-group">
					<label htmlFor="img-upload" className="col-sm-3 control-label">
						New Picture
					</label>
					<div className="col-sm-9">
						<span
							className={cn(
								'btn',
								'btn-labeled',
								'btn-success',
								'fileinput-button',
								{ hidden: tempImages.length > 0 }
							)}
						>
							<span className="btn-label">
								<i className="fa fa-plus" />
							</span>
							<span>Choose File</span>
							<input
								id="img-upload"
								type="file"
								name="file"
								accept="image/*"
								onChange={handleImageChange}
							/>
						</span>
						{tempImages.length > 0 && (
							<React.Fragment>
								<div className="pull-left upload-preview-container">
									{tempImages.map((imageData) => (
										<React.Fragment key={imageData.name}>
											<div className="upload-preview">
												<img src={URL.createObjectURL(imageData)} />
											</div>
											<div className="upload-filename">{imageData.name}</div>
										</React.Fragment>
									))}
								</div>
								<div className="ml-lg upload-action pull-left">
									<Button
										primary
										className="upload"
										title="Upload File"
										onClick={handleUploadImage}
									/>
									<Button
										className="ml"
										title="Cancel"
										onClick={() => setTempImages([])}
									/>
								</div>
							</React.Fragment>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

ProfilePic.propTypes = {
	user: PropTypes.object,
};

export default ProfilePic;
